import { useFetch } from "../hooks/useFetch";
//import { apiUrl as api_url } from "utils/helpers/enviroment.helpers";

export const useTurnos = () => {

    const {get, del, error, loading} = useFetch(window.__CONFIG__.apiPrincipal + 'Turnos/');

    // useEffect(() => console.count("Render useUsers"))

    const service = {

        getByDni(dni, callbackSuccess, callbackError) {
            get("dni/" + dni, callbackSuccess, callbackError);
        },

        getById(id, callbackSuccess, callbackError) {
            get(id, callbackSuccess, callbackError);
        }, 

        del({id, dni}, callbackSuccess, callbackError) {
            del(id + "/" + dni, callbackSuccess, callbackError)
        }

    }

    return [
        service,
        error, 
        loading 
    ];
}